import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { User, Mail, Phone, Lock, Camera, Save, Package, Heart, LogOut, Edit2 } from 'lucide-react';
import Header from './components/Header1';
import Footer from './components/Footer1';
import Button from './components/Button';

import { devLog } from '../../../utils/devLog';
const Profile = () => {
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState('profile');
    const [isEditing, setIsEditing] = useState(false);
    const [profileData, setProfileData] = useState({
        fullName: 'Ananya Sharma', email: 'ananya@example.com', phone: '+91 98765 43210',
        avatar: 'https://ui-avatars.com/api/?name=Ananya+Sharma&size=200&background=2D6A4F&color=fff',
        address: { street: '42 Fashion Lane', city: 'Mumbai', state: 'Maharashtra', pincode: '400001' },
        bio: 'Passionate about Indian ethnic wear and traditional craftsmanship.',
    });
    const [passwordData, setPasswordData] = useState({ currentPassword: '', newPassword: '', confirmPassword: '' });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (name.includes('.')) {
            const [parent, child] = name.split('.');
            setProfileData({ ...profileData, [parent]: { ...profileData[parent], [child]: value } });
        } else {
            setProfileData({ ...profileData, [name]: value });
        }
    };

    const handlePasswordChange = (e) => {
        const { name, value } = e.target;
        setPasswordData({ ...passwordData, [name]: value });
    };

    const handleSaveProfile = (e) => { e.preventDefault(); devLog.log('Profile updated:', profileData); setIsEditing(false); };
    const handleChangePassword = (e) => {
        e.preventDefault();
        if (passwordData.newPassword !== passwordData.confirmPassword) { alert('Passwords do not match!'); return; }
        devLog.log('Password changed');
        setPasswordData({ currentPassword: '', newPassword: '', confirmPassword: '' });
    };

    const tabs = [
        { id: 'profile', label: 'Profile', icon: User },
        { id: 'orders', label: 'Orders', icon: Package },
        { id: 'wishlist', label: 'Wishlist', icon: Heart },
        { id: 'security', label: 'Security', icon: Lock },
    ];

    const inputClass = "w-full px-4 py-2.5 md:py-3 border border-[#E5E7EB] text-sm focus:outline-none focus:border-[#2D6A4F] transition-colors disabled:bg-[#F8FAF8] disabled:text-[#6B7280]";

    return (
        <div className="min-h-screen bg-white" style={{ fontFamily: "'Poppins', sans-serif" }}>
            <link href="https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap" rel="stylesheet" />
            <Header cartCount={3} />

            <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8 py-6 md:py-10 lg:py-12">
                <h1 className="text-2xl md:text-3xl font-semibold text-[#1A1A1A] mb-6 md:mb-8">My Account</h1>

                <div className="grid grid-cols-1 lg:grid-cols-4 gap-6 md:gap-8">
                    {/* Sidebar */}
                    <div className="lg:col-span-1">
                        <div className="border border-[#E5E7EB] p-5">
                            <div className="text-center mb-5">
                                <div className="relative inline-block">
                                    <img src={profileData.avatar} alt={profileData.fullName} className="w-20 h-20 rounded-full mx-auto mb-3 border-2 border-[#E5E7EB]" />
                                    <button className="absolute bottom-3 right-0 p-1.5 bg-[#2D6A4F] rounded-full hover:bg-[#1B4332] transition-colors">
                                        <Camera size={12} className="text-white" />
                                    </button>
                                </div>
                                <h3 className="text-sm font-semibold text-[#1A1A1A]">{profileData.fullName}</h3>
                                <p className="text-xs text-[#6B7280]">{profileData.email}</p>
                            </div>
                            <div className="space-y-1">
                                {tabs.map(tab => {
                                    const Icon = tab.icon;
                                    return (
                                        <button key={tab.id} onClick={() => setActiveTab(tab.id)}
                                            className={`w-full flex items-center gap-3 px-3 py-2.5 text-sm transition-all ${
                                                activeTab === tab.id ? 'bg-[#2D6A4F] text-white' : 'text-[#1A1A1A] hover:bg-[#F8FAF8]'
                                            }`}>
                                            <Icon size={16} /> <span className="font-medium">{tab.label}</span>
                                        </button>
                                    );
                                })}
                                <button onClick={() => navigate('/template1/login')} className="w-full flex items-center gap-3 px-3 py-2.5 text-sm text-red-500 hover:bg-red-50 transition-all">
                                    <LogOut size={16} /> <span className="font-medium">Logout</span>
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* Main Content */}
                    <div className="lg:col-span-3">
                        {activeTab === 'profile' && (
                            <div className="border border-[#E5E7EB] p-5 md:p-6">
                                <div className="flex justify-between items-center mb-5">
                                    <h2 className="text-lg font-semibold text-[#1A1A1A]">Profile Information</h2>
                                    <Button variant={isEditing ? 'secondary' : 'primary'} size="sm" onClick={() => setIsEditing(!isEditing)}>
                                        <Edit2 size={14} className="mr-1.5" /> {isEditing ? 'Cancel' : 'Edit'}
                                    </Button>
                                </div>
                                <form onSubmit={handleSaveProfile} className="space-y-5">
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                        <div><label className="block text-xs font-medium text-[#1A1A1A] mb-1.5">Full Name</label><input type="text" name="fullName" value={profileData.fullName} onChange={handleInputChange} disabled={!isEditing} className={inputClass} /></div>
                                        <div><label className="block text-xs font-medium text-[#1A1A1A] mb-1.5">Email</label><input type="email" name="email" value={profileData.email} onChange={handleInputChange} disabled={!isEditing} className={inputClass} /></div>
                                        <div><label className="block text-xs font-medium text-[#1A1A1A] mb-1.5">Phone</label><input type="tel" name="phone" value={profileData.phone} onChange={handleInputChange} disabled={!isEditing} className={inputClass} /></div>
                                    </div>
                                    <div><label className="block text-xs font-medium text-[#1A1A1A] mb-1.5">Bio</label><textarea name="bio" value={profileData.bio} onChange={handleInputChange} disabled={!isEditing} rows="2" className={`${inputClass} resize-none`} /></div>
                                    <div>
                                        <h3 className="text-sm font-medium text-[#1A1A1A] mb-3">Address</h3>
                                        <div className="space-y-3">
                                            <div><label className="block text-xs font-medium text-[#1A1A1A] mb-1.5">Street</label><input type="text" name="address.street" value={profileData.address.street} onChange={handleInputChange} disabled={!isEditing} className={inputClass} /></div>
                                            <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                                                <div><label className="block text-xs font-medium text-[#1A1A1A] mb-1.5">City</label><input type="text" name="address.city" value={profileData.address.city} onChange={handleInputChange} disabled={!isEditing} className={inputClass} /></div>
                                                <div><label className="block text-xs font-medium text-[#1A1A1A] mb-1.5">State</label><input type="text" name="address.state" value={profileData.address.state} onChange={handleInputChange} disabled={!isEditing} className={inputClass} /></div>
                                                <div><label className="block text-xs font-medium text-[#1A1A1A] mb-1.5">PIN Code</label><input type="text" name="address.pincode" value={profileData.address.pincode} onChange={handleInputChange} disabled={!isEditing} className={inputClass} /></div>
                                            </div>
                                        </div>
                                    </div>
                                    {isEditing && <Button type="submit" variant="primary" size="lg"><Save size={16} className="mr-2" /> Save Changes</Button>}
                                </form>
                            </div>
                        )}

                        {activeTab === 'orders' && (
                            <div className="border border-[#E5E7EB] p-5 md:p-6 text-center py-12">
                                <Package size={48} className="text-[#D1D5DB] mx-auto mb-3" />
                                <p className="text-sm text-[#6B7280] mb-4">View all your orders in one place</p>
                                <Button variant="primary" onClick={() => navigate('/template1/orders')}>View All Orders</Button>
                            </div>
                        )}

                        {activeTab === 'wishlist' && (
                            <div className="border border-[#E5E7EB] p-5 md:p-6 text-center py-12">
                                <Heart size={48} className="text-[#D1D5DB] mx-auto mb-3" />
                                <p className="text-sm text-[#6B7280] mb-4">Your wishlist is empty</p>
                                <Button variant="primary" onClick={() => navigate('/template1/shop')}>Start Shopping</Button>
                            </div>
                        )}

                        {activeTab === 'security' && (
                            <div className="border border-[#E5E7EB] p-5 md:p-6">
                                <h2 className="text-lg font-semibold text-[#1A1A1A] mb-5">Change Password</h2>
                                <form onSubmit={handleChangePassword} className="space-y-4 max-w-md">
                                    <div><label className="block text-xs font-medium text-[#1A1A1A] mb-1.5">Current Password</label><input type="password" name="currentPassword" value={passwordData.currentPassword} onChange={handlePasswordChange} className={inputClass} /></div>
                                    <div><label className="block text-xs font-medium text-[#1A1A1A] mb-1.5">New Password</label><input type="password" name="newPassword" value={passwordData.newPassword} onChange={handlePasswordChange} minLength="8" className={inputClass} /></div>
                                    <div><label className="block text-xs font-medium text-[#1A1A1A] mb-1.5">Confirm Password</label><input type="password" name="confirmPassword" value={passwordData.confirmPassword} onChange={handlePasswordChange} minLength="8" className={inputClass} /></div>
                                    <Button type="submit" variant="primary" size="lg"><Lock size={16} className="mr-2" /> Update Password</Button>
                                </form>
                            </div>
                        )}
                    </div>
                </div>
            </div>

            <Footer />
        </div>
    );
};

export default Profile;
